import dayjs from 'dayjs'

import 'dayjs/locale/en'
import 'dayjs/locale/es'
import 'dayjs/locale/nl'
import 'dayjs/locale/it'
import 'dayjs/locale/fr'
import 'dayjs/locale/pt'
import 'dayjs/locale/de'
import 'dayjs/locale/pl'
import 'dayjs/locale/ca'
import 'dayjs/locale/sk'
import 'dayjs/locale/ro'
import 'dayjs/locale/pl'
import 'dayjs/locale/cs'
import 'dayjs/locale/hu'
import isSameOrBefore from 'dayjs/plugin/isSameOrBefore'
import customParseFormat from 'dayjs/plugin/customParseFormat'
import relativeTime from 'dayjs/plugin/relativeTime'
import localeData from 'dayjs/plugin/localeData'
import timezone from 'dayjs/plugin/timezone'
import utc from 'dayjs/plugin/utc'

dayjs.extend(isSameOrBefore)
dayjs.extend(customParseFormat)
dayjs.extend(relativeTime)
dayjs.extend(localeData)
dayjs.extend(timezone)
dayjs.extend(utc)

dayjs.locale('en')

export default (context, inject) => {
  context.$dayjs = dayjs
  inject('dayjs', dayjs)
}
